import { Card, Col, Row, Button } from "antd";
import React, { useEffect, useState, useCallback } from "react";
import { ExportOutlined } from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
// 1. Import useSelector to read from the Redux store
import { useDispatch, useSelector } from "react-redux";
import {
  getEndorCalcPolicyDetails,
  getEndorCalcRackRateData,
} from "../../../Action/Actions";
import moment from "moment";
import { downloadCSV } from "../../FileSaver/FileSaver";
import EndorseRackRatePolicyList, { columns } from "./EndorseRackRatePolicyList";
// 2. Import your selector for corporate_id (ensure the path is correct)
import { getCorporateId } from "../../login/LoginSlice"; // Adjust this path to your authSlice file

const Index = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // 3. Get the corporateId from the Redux store using the selector
  const corporateId = useSelector(getCorporateId);

  const [loading, setLoading] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    pageSizeOptions: ["10", "20", "50", "100"],
    showTotal: (total, range) =>
      `Showing ${range[0]} to ${range[1]} of ${total} entries`,
  });

  const fetchEndorCalcPolicyDetails = useCallback(() => {
    // 4. Add a check to ensure corporateId is available before fetching
    if (!corporateId) {
      console.log("Corporate ID not found, skipping API call.");
      return;
    }
    setLoading(true);
    // 5. Pass the corporateId to your action creator
    dispatch(getEndorCalcPolicyDetails(corporateId))
      .then((data) => {
        const seenIds = new Set();
        const updatedData = (data?.policy_details || []).map((item, index) => {
          if (!item.id || seenIds.has(item.id)) {
            console.warn("Item with missing or duplicate ID found:", item);
            return {
              ...item,
              key: `fallback-${index}-${item.policy_number || ""}`,
              created_at: moment(item?.created_at).format("DD-MM-YYYY"),
              policy_start_date: item?.policy_start_date || null,
              policy_end_date: item?.policy_end_date || null,
            };
          }
          seenIds.add(item.id);
          return {
            ...item,
            key: item.id,
            created_at: moment(item?.created_at).format("DD-MM-YYYY"),
            policy_start_date: item?.policy_start_date || null,
            policy_end_date: item?.policy_end_date || null,
          };
        });

        setFilteredData(updatedData);
        setPagination((prev) => ({
          ...prev,
          total: updatedData.length,
          current: 1,
        }));
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
    // 6. Add corporateId to the useCallback dependency array
  }, [dispatch, corporateId]);

  useEffect(() => {
    document.title = `Endorsement Policy Details`;
    fetchEndorCalcPolicyDetails();
  }, [fetchEndorCalcPolicyDetails]);

  const handleDownloadCSV = () => {
    const columnDefinitions = columns(handlePolicyAction, pagination);
    downloadCSV(filteredData, columnDefinitions, "rack_rate_list.csv");
  };

  const handleTableChange = (newPagination) => {
    setPagination(newPagination);
  };

  const handlePolicyAction = (record) => {
    console.log("record", record);
    dispatch(getEndorCalcRackRateData(record?.id))
      .then((data) => {
        console.log("data", data);
        navigate("/corporate/rackrate", { state: { data } });
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  return (
    <div className="site-card-wrapper">
      <Row gutter={16}>
        <Col style={{ width: "100%" }}>
          <Card
            title={
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <span className="corp-title">
                  Endorsement Rack Rate Policies
                </span>
                <div className="d-flex gap-3">
                  {/* <Link to="/corporate/add_rackrates">
                    <Button type="primary">Add Rack Rate</Button>
                  </Link> */}
                  <Button
                    type="primary"
                    onClick={handleDownloadCSV}
                    icon={<ExportOutlined />}
                    className="d-flex align-items-center"
                  >
                    Export
                  </Button>
                </div>
              </div>
            }
            bordered={false}
          >
            <EndorseRackRatePolicyList
              loading={loading}
              filteredData={filteredData}
              handlePolicyAction={handlePolicyAction}
              pagination={pagination}
              handleTableChange={handleTableChange}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Index;